import { pxToRem } from '@dotcom/crown-ui';

export const buttons = {
  buttonBorderRadius: '30px',
  /* Primary Colors */
  primaryButtonBackgroundColor: '#232323', // charcoal-grey
  primaryButtonTextColor: '#f6eee1', // uk-light-yellow
  primaryButtonBorderColor: '#232323', // charcoal-grey
  // Box shadows
  primaryButtonHoverBoxShadow: 'none',
  primaryButtonActiveBoxShadow: 'none',
  // Hover
  primaryButtonHoverBackgroundColor: '#f6eee1', // uk-light-yellow
  primaryButtonHoverTextColor: '#232323', // charcoal-grey
  primaryButtonHoverBorderColor: '#232323', // charcoal-grey
  // Disabled
  primaryButtonDisabledBackgroundColor: '#BDBDBD', // medium-gray
  primaryButtonDisabledTextColor: '#FFFFFF', // white
  primaryButtonDisabledBorderColor: '#BDBDBD', // medium-gray
  // Borders
  primaryButtonBorderWidth: '1.5px',
  primaryButtonPaddingVertical: pxToRem(14),
  primaryButtonPaddingHorizontal: pxToRem(24),
  /* Secondary Colors */
  secondaryButtonBackgroundColor: '#f6eee1', // uk-light-yellow
  secondaryButtonTextColor: '#232323', // charcoal-grey
  secondaryButtonBorderColor: '#232323', // charcoal-grey
  // Box shadows
  secondaryButtonHoverBoxShadow: 'none',
  secondaryButtonActiveBoxShadow: 'none',
  // Hover
  secondaryButtonHoverBackgroundColor: '#FFFFFF', // charcoal-grey
  secondaryButtonHoverTextColor: '#232323', // uk-light-yellow
  secondaryButtonHoverBorderColor: '#232323', // uk-light-yellow
  // Disabled
  secondaryButtonDisabledBackgroundColor: '#FFFFFF', // white
  secondaryButtonDisabledTextColor: '#E0E0E0', // light-grey
  secondaryButtonDisabledBorderColor: '#E0E0E0', // light-grey
  // Borders
  secondaryButtonBorderWidth: '1.5px',
  /* Tertiary Colors */
  tertiaryButtonBackgroundColor: '#FFFFFF', // white
  tertiaryButtonTextColor: '#232323', // charcoal-grey
  tertiaryButtonBorderColor: '#E0E0E0', // light-gray
  teriaryButtonBorderType: 'dotted',
  // Hover
  tertiaryButtonHoverBackgroundColor: '#FFFFFF', // white
  tertiaryButtonHoverTextColor: '#232323', // charcoal-grey
  tertiaryButtonHoverBorderColor: '#E0E0E0', // light-gray
  tertiaryButtonHoverBoxShadow: '0 0.25rem 0.5rem 0 rgba(0,0,0,.16)',
  // Disabled
  tertiaryButtonDisabledBorderColor: '#FFFFFF', // white
  tertiaryButtonDisabledBackgroundColor: '#BDBDBD', // medium-gray
  tertiaryButtonDisabledTextColor: '#BDBDBD', // medium-gray
  // Link Button
  linkButtonColor: '#232323',
  // text color
  textButtonColor: '#232323', // charcoal-grey
  // Quick Action
  quickActionButtonBorderRadius: pxToRem(30),
  quickActionButtonPaddingVertical: pxToRem(26),
  quickActionButtonPaddingHorizontal: pxToRem(14),
  quickActionButtonBorderWidth: pxToRem(1),
  // Quick Action - Deactivated
  quickActionDeactivatedBorderColor: '#E0E0E0', // light-gray
  quickActionDeactivatedDisabledBorderColor: '#BDBDBD', // medium-gray
  quickActionDeactivatedDisabledTextColor: '#BDBDBD', // medium-gray
  quickActionDeactivatedActiveTextColor: '#BDBDBD', // medium-gray
  // Quick Action - Activated
  quickActionActivatedBorderColor: '#E0E0E0', // light-gray
  quickActionActivatedTextColor: '#232323', // charcoal-grey
  quickActionActivatedHoverTextColor: '#B39DDB', // pastel-violet
  /* Save Button */
  saveButtonBackgroundColor: '#FFFFFF', // white
  saveButtonTextColor: '#232323', // charcoal-grey
  saveButtonIconColor: '#232323', // charcoal-grey

  /* Carousel Thumb Button */
  carouselThumbImageMaxWidth: pxToRem(60),
  carouselThumbImageMaxHeight: pxToRem(42),
  carouselButtonGap: pxToRem(0),
};
